import { handleActions } from "redux-actions";

import {
    getSQSQueues,
    getSQSQueuesSuccess,
    getSQSQueuesError,
    clearQueues
} from "modules/Queues/services/Queues/actions";

const initialState = {
    isLoading: false,
    queues: [],
    count: 0,
    total_messages_available: 0,
    total_messages_in_flight: 0,
};

export const queuesEntriesReducer = handleActions(
    {
        [clearQueues]: () => ({ ...initialState }),
        [getSQSQueues]: (state) => ({
            ...state,
            queues: [],
            count: 0,
            isLoading: true
        }),
        [getSQSQueuesSuccess]: (state, { payload }) => ({
            ...state,
            isLoading: false,
            ...payload
        }),
        [getSQSQueuesError]: (state) => ({
            ...state,
            isLoading: false
        }),
    },
    initialState
);
